/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useState } from 'react';
import { Announce, LoadingIndicator } from 'react-magma-dom';
import { StyledEmbed, StyledResponsivePadding, StyledResponsiveWrapper } from '../Styled/StyledWistia';

declare global {
  interface Window {
    _wq: Array<WistiaItem>;
  }
}

interface WistiaItem {
  id: string;
  onHasData: () => void;
}

interface IVideo {
  id: string;
}

export const Video = (props: IVideo): JSX.Element => {
  const { id } = props;
  const [showLoader, setShowLoader] = useState<boolean>(true);

  useEffect(() => {
    if (!document.getElementById('wistia_external')) {
      const wistiaExternal = document.createElement('script');
      wistiaExternal.id = 'wistia_external';
      wistiaExternal.src = 'https://fast.wistia.com/assets/external/E-v1.js';
      wistiaExternal.type = 'text/javascript';
      wistiaExternal.async = true;
      document.body.appendChild(wistiaExternal);
    }

    window._wq = (window._wq as Array<WistiaItem>) || [];
    window._wq.push({
      id: id,
      onHasData: () => {
        setShowLoader(false);
      },
    });

    // @ts-ignore
    window._wq.push((W: { consent: (isConsent: boolean) => void }): void => {
      W.consent(false);
    });

    setTimeout(() => {
      setShowLoader(false);
    }, 5000);
  });

  return (
    <>
      <Announce>{showLoader && <LoadingIndicator />}</Announce>
      <StyledResponsivePadding data-testid="wistia-video" className="wistia_responsive_padding">
        <StyledResponsiveWrapper className="wistia_responsive_wrapper">
          <StyledEmbed className={`wistia_embed wistia_async_${id} autoPlay=false`} />
        </StyledResponsiveWrapper>
      </StyledResponsivePadding>
    </>
  );
};
